import React, { useState, useEffect } from 'react';
import { isAuthenticated } from "../../store/action/auth";
import { updateUser, updateUserOnLocal, getUser } from "../../store/action/user";
import {trackEvent} from "../../services/analytics";
import PaymentWarning from "../../components/warnings/Payment";
import CourierSetting from "./Courier";
import {Nav} from "react-bootstrap";
import Freshchat from "../../components/atoms/FreshChat";

const Setting = () => {
    const [ loading, setLoading ] = useState(true);
    const [ tab , setTab ] = useState('profile');
    const [ currentUser, setCurrentUser ] = useState({
       firstName:'',
       lastName:'',
       email:'',
       phone:'',
       organizationName:'',
       isChanged:false,
       bankAccounts: []
   });
    const [ bank, setBank ] = useState({
        name:'',
        bank:'',
        account:''
    });

   const { user , token } = isAuthenticated();

   useEffect(() => {
       _fetchData()
   }, []);

   const _fetchData = async () => {
       try {
           const usr = await getUser(user._id, token);
           if (usr.success) {
               setCurrentUser({
                   firstName: usr.first_name,
                   lastName: usr.last_name,
                   email: usr.email,
                   phone: usr.phone,
                   organizationName: usr.organization.name,
                   bankAccounts: usr.organization.bank_accounts
               })
           } else {
               alert(usr.error)
           }
           setLoading(false)
       } catch (e) {
           console.log (e);
           alert("Gagal ambil data akun. Mohon ulangi kembali.")
       }
   };

   const onChange = name => e => {
       const value = e.target.value;
       setCurrentUser({
           ...currentUser,
           [name]: value,
           isChanged: true
       });
   };

   const onBankChange = name => e => {
       const value = e.target.value;
       setBank({
           ...bank,
           [name]: value
       });
   };

   const onAddBank = () => {
       if (!bank.name || !bank.bank || !bank.account) {
           alert("Data bank kurang lengkap");
           return
       }
       let copyBank = currentUser.bankAccounts;
       copyBank.push(bank);
       setCurrentUser({
           ...currentUser,
           bankAccounts:copyBank,
           isChanged: true
       });
       setBank({
           name:'',
           bank:'',
           account:''
       })
   };

   const onRemoveBank = (name) => {
       let copyBank = currentUser.bankAccounts;
       let filteredBankAccounts = copyBank.filter(i => i !== name);
       setCurrentUser({
           ...currentUser,
           bankAccounts: filteredBankAccounts,
           isChanged: true
       });
   };

   const onSubmitUser = async () => {
       try {
           const res = await updateUser(token, currentUser);
           if (res.success) {
                trackEvent("User Updated",{
                   action: "track",
                   category: "Users",
                   label: 'Update User Profile',
                   event: "Click"
               });

               updateUserOnLocal(res.user,() => {
                   alert('Profil berhasil di update');
                   window.location.reload();
               });
           } else {
               alert("Gagal update user. Coba ulangi kembali :)")
           }
       } catch (err) {
           console.log (err);
           alert("Gagal update user. Coba ulangi kembali :)")
       }
   };

    const nav = () => {
        return (
            <Nav variant="tabs" className="px-4" defaultActiveKey="active">
                <Nav.Item className="col-3 px-0 text-center">
                    <Nav.Link eventKey="active" onSelect={() => setTab('profile')}>
                        PROFILE
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item className="col-3 px-0 text-center">
                    <Nav.Link eventKey="catalog" onSelect={() => setTab('courier')}>
                        KURIR
                    </Nav.Link>
                </Nav.Item>
            </Nav>
        )
    };

    const content = () => {
        if (tab === 'profile') {
            return profileSetting()
        } else if (tab === 'courier') {
            return <CourierSetting/>
        } 
    };

    const profileSetting = () => (
        <div className="p-4">
            <h6>Detil Pribadi </h6>
            <div>
                <div className="form-group form-row">
                    <label className="col-sm-2 col-form-label">Nama Lengkap</label>
                    <div id="first-name-setting" className="col-sm-5">
                        <input
                            type="text"
                            className="form-control"
                            onChange={onChange('firstName')}
                            id="firstName"
                            placeholder="Nama depan"
                            value={currentUser.firstName}/>
                    </div>
                    <div className="col-sm-5">
                        <input
                            type="text"
                            className="form-control"
                            onChange={onChange('lastName')}
                            id="lastName"
                            placeholder="Nama belakang"
                            value={currentUser.lastName}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-2"/>
                    <div className="col-10">
                        <p>
                            Nama lengkap adalah nama yang akan digunakan ketika Biteship memesan kurir.
                            Nama tersebut akan dicantumkan dalam nota driver untuk memudahkan pengambilan barang.
                        </p>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">Email</label>
                    <div className="col-sm-10">
                        <input
                            type="text"
                            className="form-control"
                            onChange={onChange('email')}
                            id="email"
                            placeholder="Email Anda"
                            value={currentUser.email}/>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">Nomor Telepon</label>
                    <div className="col-sm-10">
                        <input
                            type="number"
                            className="form-control"
                            onChange={onChange('phone')}
                            id="phone"
                            placeholder="Nomor Telepon"
                            value={currentUser.phone}/>
                    </div>
                </div>
                <hr/>
                <h6>Detil Perusahaan </h6>
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label">Nama Perusahaan</label>
                    <div className="col-sm-10">
                        <input
                            type="text"
                            className="form-control"
                            onChange={onChange('organizationName')}
                            id="email"
                            placeholder="Nama Perusahaan Anda"
                            value={currentUser.organizationName}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-2">
                        <label className="col-form-label">Rekening Bank</label>
                    </div>
                    <div className="col-10">
                        {
                            currentUser.bankAccounts.map((i, idx) => (
                                <div key={idx} className="px-3">
                                    <div className="row bg-lighter border rounded py-2 mb-2">
                                        <div className="col-sm-3">
                                            <b>{i.name}</b>
                                        </div>
                                        <div className="col-sm-3">
                                            <b>{i.bank}</b>
                                        </div>
                                        <div className="col-sm-5">
                                            {i.account}
                                        </div>
                                        <div className="col-sm-1">
                                            <a onClick={() => onRemoveBank(i)}
                                               className="action-item mr-2"
                                               data-toggle="tooltip"
                                               title="Remove">
                                                <i className="fas fa-times"></i>
                                            </a>
                                        </div>

                                    </div>
                                </div>
                            ))
                        }
                        <div className="form-row">
                            <div className="input-group col-sm-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Nama pemilik rekening"
                                    onChange={onBankChange('name')}
                                    value={bank.name}
                                />
                            </div>
                            <div className="input-group col-sm-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Nama Bank cth: BCA, Mandiri"
                                    onChange={onBankChange('bank')}
                                    value={bank.bank}
                                />
                            </div>
                            <div className="input-group col-sm-4">
                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Nomor Rekening Bank"
                                    onChange={onBankChange('account')}
                                    value={bank.account}
                                />
                            </div>
                            <div className="input-group col-sm-2">
                                <button
                                    onClick={onAddBank}
                                    className="btn-block btn btn-outline-primary"
                                    type="button"
                                >
                                    Tambah
                                </button>
                            </div>
                        </div>
                    </div>
                </div>


                <div
                    className="mt-4"
                    style={{display: `flex`, justifyContent: `flex-end`}}
                >
                    <button
                        onClick={onSubmitUser}
                        className={`btn col-3 ${currentUser.isChanged ? "btn-primary" : "btn-secondary"}`}
                    >
                        Simpan
                    </button>
                </div>
            </div>
        </div>
    );

   if (loading) {
       return (
           <div className="bg-white rounded shadow">
               <div className="p-4">
                   <h5>Pengaturan </h5>
                   <div className="py-4">Loading...</div>
               </div>
           </div>
       )
   }
   return (
       <div>
           <PaymentWarning user={user} type={"top"}/>
           <div className="bg-white rounded shadow">
               <div>
                   <div className="p-4">
                       <h5>Pengaturan </h5>
                   </div>

                   { nav() }
                   { content() }

               </div>
           </div>
       </div>
   )
};


export default Setting;
